import React from "react";

function WpTitle({ title }: { title: string }) {
  return (
    <div className="wp-title">
      <img src="/assets/common/plus.svg" alt="" />
      <div className="title">{title}</div>
    </div>
  );
}

export default WpTitle;
